import { requestsLikeGenerate } from '../requestsLike.js';
/**
 * python/requests
 */
export const pythonRequests = {
    target: 'python',
    client: 'requests',
    title: 'Requests',
    generate(request, configuration) {
        return requestsLikeGenerate('requests', request, configuration);
    },
};
